export const TYPE_OPTIONS = ['FR', 'Story'];
